import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ActiveInactiveFor, FocusInputType, KeyValues10, KeyValues5, LocalService, NumericConfig, ProductEntryType, QrLabelVariableType, Status } from 'src/service/local.service';
import { ProductManagementService } from 'src/service/product-management.service';
import { PurchaseEntryService } from 'src/service/purchase-entry.service';

@Component({
  selector: 'app-raw-material-inventory-config',
  templateUrl: './raw-material-inventory-config.component.html',
  styleUrl: './raw-material-inventory-config.component.scss'
})
export class RawMaterialInventoryConfigComponent {
  QrLabelVariableType = QrLabelVariableType;
  ActiveInactiveFor = ActiveInactiveFor;

  @ViewChild('content_raw_inventory_config')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();


  @Input() productId: string = ''; @Input() businessId: string = ''; @Input() measurementType: number = 0; @Input() countryCode: string = ''; @Input() productCode: string = ''; @Input() productName: string = ''; @Input() isRawInventoryEnabled = false;

  searchItems: KeyValues10[] = []; isShowSpinnerCount = 0; deductQty: number | null = null; rawProductId: string = ''; rawMeasurementType: number = 1; items: KeyValues10[] = [];

  numericConfig: NumericConfig = { isDecimalAllowed: true, isStartWithZeroAllowed: true, maxDecimalDigits: 10 } as NumericConfig;

  pageNameId = '_raw_inventory_';
  elementIds: any = {
    product_dd: 'dd' + this.pageNameId + 'product',
    qty: 'input' + this.pageNameId + 'qty',
    btn_add: 'btn' + this.pageNameId + 'add'
  };

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private purchaseEntryService: PurchaseEntryService, private productManagementService: ProductManagementService) {

  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.onReset();

    this.productManagementService.getProductRawInventoryConfigs(this.productId, this.countryCode).subscribe(result => {
      this.items = result
    });
  }

  onSearch(strSearchKey: string = '') {
    if (strSearchKey && strSearchKey.trim().length > 2) {
      this.isShowSpinnerCount++;
      this.purchaseEntryService.getSearchedProducts(this.businessId, strSearchKey, ProductEntryType.PurchaseEntryOnly).subscribe(result => {
        this.isShowSpinnerCount--;
        this.searchItems = result;
      });
    } else {
      this.searchItems = [];
    }
  }

  onSave() {
    const data: KeyValues10 = {
      v1: this.businessId,
      v2: this.productId,
      v3: this.rawProductId,
      v4: (this.deductQty ? this.deductQty : 0).toString()
    } as KeyValues10;
    this.productManagementService.saveProductRawInventoryConfig(data, this.countryCode).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }

  onActiveInactiveFor(key: string, activeInactiveFor: ActiveInactiveFor) {
    this.productManagementService.activeInactiveStatus(key, activeInactiveFor).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success && activeInactiveFor == ActiveInactiveFor.DeleteRawInventoryForProduct) {
        this.onLoad();
      }
    });
  }

  onSetRawProduct() {
    const item = this.searchItems.find(x => x.key == this.rawProductId);
    if (item) {
      this.rawMeasurementType = item.v6 ? parseInt(item.v6) : 0;
    }
    this.localService.onFocusNextInput(this.elementIds.qty, FocusInputType.TextBox);
  }

  onReset() {
    this.rawProductId = '';
    this.rawMeasurementType = 0;
    this.deductQty = null;
    this.searchItems = [];
    this.localService.onFocusNextInput(this.elementIds.product_dd, FocusInputType.NgxDropDown);
  }
}
